import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoTakim } from './FikoTakim';
import { FikoTakimFrezeleme } from './FikoTakimFrezeleme';
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';
import { FikoVektorTakimYol3Dv1 } from './FikoVektorTakimYol3dv1';

export class FikoTakimYoluv1 extends FikoGrup {
    override type: any = "FikoTakimYoluv1";
    /** */
    sayac = 1;
    /** */
    parametreler = [{
        ismi: "Pozisyon",
        turu: "cubuk",
        min: 0,
        maks: 1,
        adim: 1,
        degeri: 0,
        degisti: () => { },
    }
    ]

    /** */
    sagButonlar: any[] = [
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                import('../fiko-similasyon-v1/fiko-similasyon-v1.component').then(m => {
                    const gosterim = this.sahne?.anaGosterim ?? (this as any).parent?.sahne?.anaGosterim;
                    if (!gosterim?.DialogFiko) { console.warn('DialogFiko bulunamadi'); return; }
                    gosterim.DialogFiko.ac({
                        bilesen: m.FikoSimilasyonV1Component,
                        parametreler: { anaNesne: this },
                        ayarlar: { baslik: 'Similasyon', simgeResim: './simgeler/takimyolu.webp' }
                    });
                });
            }
        }
    ]
    /** */
    sagMenu: any[] = [
        {
            simge: null,
            baslik: "Düzenle",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoApt.ac(this as any);
            }
        },
        {
            simge: null,
            baslik: "Sil",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    aracCubugu: any[] = [
        {
            simge: "edit",
            baslik: "Düzenle",
            tiklandi: () => {

            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);
                this.sahne.anaGosterim.aktifItem = null;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    // aktiviteler: any[] = []
    // program: any;
    // apt: string & Array<string> & Array<any> | any
    // json: any;
    // similasyonCizgisi = new THREE.Line(new THREE.BufferGeometry(), new THREE.LineBasicMaterial({ color: 0xffffff, vertexColors: true }));

    public override get liste(): any[] {
        return this.children;
    }
    /** */

    private _noktalar: FikoVektorTakimYol3Dv1[];
    public get noktalar(): FikoVektorTakimYol3Dv1[] {
        return this._noktalar;
    }
    public set noktalar(v: FikoVektorTakimYol3Dv1[]) {
        this._noktalar = v;
    }

    aktivite: any;
    constructor(public override sahne?: FikoSahne, name?: string, noktalar1?: any) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/takimyolu.webp";
        // this.similasyonCizgisi.frustumCulled = false;
        // this.similasyonCizgisi.name = "Fiko Similasyon Çizgisi";
        this._noktalar = noktalar1;
    }

}